export default __webpack_public_path__ + "static/bg-billboard-1e4defa703528b5170ef4ac5c9a6fddc.png";